import { store } from '@/state/store';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

export function FN_IMAGE_ASSET__update_generation_layout_image_edit(images_map: Map<string, DTO__image_asset>) {
  let { g_image_edit__field: field } = store.getState().slice_ui;

  if (field.is_stub()) return; //nothing to update
  if (!field.asset.is_stub()) return; //already initialized

  if (!images_map.has(field.hash_sha256_content)) return; //not loaded yet

  let image = images_map.get_or_assert(field.hash_sha256_content);
  field.image__asset_use(image.clone());

  store.dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_image_edit__field', field }));
}
